import merge from 'lodash/merge';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import forOwn from 'lodash/forOwn';
import filter from 'lodash/filter';
import values from 'lodash/values';
import keyBy from 'lodash/keyBy';
import unset from 'lodash/unset';
import { getOrFail } from 'mythil/object';

let prevNr = 0;

const getNr = () => {
    return ++prevNr;
};

export default function modelTree(tree) {
    const getModel = (id, theTree = tree) => get(theTree, id);
    const getModelOrFail = (id, theTree = tree) => getOrFail(theTree, id);
    const getChildren = (id, theTree = tree) => {
        return values(filter(theTree, { parentModelId: id }));
    };

    const getAllChildren = (id, theTree = tree) => {
        let children = getChildren(id, theTree);

        for(let child of children) {
            children = [...children, ...getChildren(child.modelId, theTree)]
        }

        return children;
    };
    
    const removeChildren = (id, theTree = tree) => {
        let newTree = {};
        let children = keyBy(getAllChildren(id, theTree), 'modelId');

        forOwn(theTree, (d, modelId) => {
            if(modelId in children) {
                return;
            }

            newTree[modelId] = d;
        });

        return modelTree(newTree);
    };

    const loadModel = (modelId, data, parentModelId = null, theTree = tree) => {
        theTree = {
            ...theTree,
            [modelId]: { ...data, modelId, parentModelId,  }
        };
        
        return modelTree(theTree);
    };

    const unloadModel = (unloadedModelId, theTree = tree) => {
        let newTree = removeChildren(unloadedModelId).tree;

        unset(newTree, unloadedModelId);

        return modelTree(newTree);
    };

    const unloadModelsExcept = (exceptModelId, theTree = tree) => {
        let newTree = {...theTree};

        let rootModelId = getRootModel(exceptModelId, theTree).modelId;

        forOwn(theTree, ({parentModelId}, modelId) => {
            if(!parentModelId && modelId !== rootModelId) {
                newTree = unloadModel(modelId, newTree).tree;
            }
        });

        return modelTree(newTree);
    };

    const unloadRootModels = (theTree = tree) => {
        let newTree = {...theTree};

        forOwn(theTree, (model, modelId) => {
            let parentModelId = model.parentModelId;

            if(!parentModelId) {
                newTree = unloadModel(modelId, newTree).tree;
            }
        });

        return modelTree(newTree);
    };

    const getRootModel = (modelId, theTree = tree) => {
        let model = getModel(modelId, theTree),
            parentId = model.parentModelId;

        while(parentId) {
            model = getModel(parentId, theTree);
            parentId = model.parentModelId;
        }

        return model;
    };

    const getSiblings = (modelId, theTree = tree) => {
        let children = getChildren(getModel(modelId, theTree).parentId, theTree);
        return children.filter((model) => model.modelId !== modelId);
    };

    const getTreeId = (prefix = '', parentId = null, theTree = tree) => {
        const nr = getNr();
        let ownId = `${prefix}_${nr}`;
        if(!parentId) { return ownId; }
        return `${getOrFail(theTree, `${parentId}.modelId`, '')}_${ownId}`;
    };

    return {
        unloadModelsExcept,
        getChildren,
        getSiblings,
        getRootModel,
        getTreeId,
        getNr,
        getModel,
        getModelOrFail,
        tree,
        loadModel,
        unloadModel,
        unloadRootModels
    }
}